export const ADD_INTERVAL = 'ADD_INTERVAL';
export const CLEAR_INTERVALS = 'CLEAR_INTERVALS';
